export default {
  install(Vue) {
    Vue.prototype.$br2nl = function (str) {
      if (typeof str === 'undefined' || str === null) {
        return ''
      }
      var breakTag = '<br />'
      return (str + '').split(breakTag).join('\n')
    }

    Vue.prototype.$checkEmail = function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }

    Vue.prototype.$setCookie = function (cname, cvalue, exdays) {
      var d = new Date()
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      var expires = 'expires=' + d.toUTCString()
      document.cookie =
        cname + '=' + cvalue + ';' + expires + ';path=/;SameSite=Strict'
    }

    Vue.prototype.$getCookie = function (cname) {
      var name = cname + '='
      var decodedCookie = decodeURIComponent(document.cookie)
      var ca = decodedCookie.split(';')
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    }

    Vue.prototype.$languages = ['en', 'hr', 'sl']

    Vue.prototype.$resultColors = ['#88C143', '#1D97E3', '#C73333']

    Vue.prototype.$tableSort = function (items, index, descending) {
      function mySorter(index, descending) {
        if (!descending) {
          return function (a, b) {
            if (typeof a[index] === 'string' || a[index] instanceof String) {
              let x = a[index].toLowerCase()
              let y = b[index].toLowerCase()
              return x.localeCompare(y, 'hr')
            } else {
              let x = a[index]
              let y = b[index]
              return x < y ? -1 : x > y ? 1 : 0
            }
          }
        } else {
          return function (a, b) {
            if (typeof a[index] === 'string' || a[index] instanceof String) {
              let x = a[index].toLowerCase()
              let y = b[index].toLowerCase()
              return y.localeCompare(x, 'hr')
            } else {
              let x = a[index]
              let y = b[index]
              return x > y ? -1 : x < y ? 1 : 0
            }
          }
        }
      }

      items.sort(mySorter(index, descending))

      return items
    }
  },
}
